export enum InformationActionType {
  Cancel = 'CANCEL',
  Primary = 'PRIMARY',
  Secondary = 'SECONDARY',
}
